import { KJUR } from "jsrsasign";
import urlJoin from "url-join-dual";
import wretch from "wretch";
import QueryStringAddon from "wretch/addons/queryString";

export const baseAPIURL = "https://api.zoom.us/";

export const doubleEncode = (str: string) => encodeURIComponent(encodeURIComponent(str));

export const generateAPIToken = ({
	APIKey,
	APISecret,
}: {
	APIKey: string;
	APISecret: string;
}) => {
	const iat = Math.round((new Date().getTime() - 30000) / 1000);
	const exp = iat + 60 * 60 * 2;
	const oHeader = { alg: "HS256", typ: "JWT" };

	const oPayload = {
		iss: APIKey,
		iat: iat,
		exp: exp,
	};

	const sHeader = JSON.stringify(oHeader);
	const sPayload = JSON.stringify(oPayload);
	const videosdk_api_token = KJUR.jws.JWS.sign(
		"HS256",
		sHeader,
		sPayload,
		APISecret,
	);
	return videosdk_api_token;
};
export const joinURL = ({
	base,
	pathList,
}: { base: string; pathList: string[] }) =>
	new URL(urlJoin(...pathList), base).toString();

type MakeApiRequestProps = {
	token: string;
	pathList: string[];
	// biome-ignore lint/suspicious/noExplicitAny: <explanation>
	options: any;
};
export const makeGetRequest = async ({
	token,
	pathList,
	options,
}: MakeApiRequestProps): Promise<unknown> => {
	const url = joinURL({
		base: baseAPIURL,
		pathList,
	});
	const res = await wretch(url)
		.addon(QueryStringAddon)
		.query(options)
		.auth(`Bearer ${token}`)
		.get()
		.json()
		.catch((e) => {
			throw new Error(e.text);
		});
	return res;
};

export const makeDeleteRequest = async ({
	token,
	pathList,
	options,
}: MakeApiRequestProps) => {
	const url = joinURL({
		base: baseAPIURL,
		pathList,
	});
	const res = await wretch(url)
		.addon(QueryStringAddon)
		.query(options)
		.auth(`Bearer ${token}`)
		.delete()
		.json()
		.catch((e) => {
			throw new Error(e.text);
		});
	return res;
};

export const makePutRequest = async ({
	token,
	pathList,
	body,
	options,
	// biome-ignore lint/suspicious/noExplicitAny: <explanation>
}: MakeApiRequestProps & { body: any }) => {
	const url = joinURL({
		base: baseAPIURL,
		pathList,
	});
	const res = await wretch(url)
		.content("application/json")
		.addon(QueryStringAddon)
		.query(options)
		.auth(`Bearer ${token}`)
		.body(JSON.stringify(body))
		.put()
		.json(j => {
			if (j) return j;
		})
		.catch((e) => {
			console.info
			console.info(e.text);
		});
	return res;
};

export const makePatchRequest = async ({
	token,
	pathList,
	body,
	options,
}: MakeApiRequestProps & {
	// biome-ignore lint/suspicious/noExplicitAny: <explanation>
	body: any;
}) => {
	const url = joinURL({
		base: baseAPIURL,
		pathList,
	});
	await wretch(url)
		.content("application/json")
		.addon(QueryStringAddon)
		.query(options)
		.auth(`Bearer ${token}`)
		.body(JSON.stringify(body))
		.patch()
		.json(j => {
			if (j) return j;
		})
		.catch((e) => {
			throw new Error(e.text);
		});
};
